import React from "react";
import styles from "../footer/FooterNavbar.module.css";
import { Navlink, navItems } from "../../controller/Navdata";
// import {Images} from "../../controller/Images"
import {
  Colorlogo,
  mslogo,
  quality,
  ISO,
  email,
  phone,
  place,
  White_Facebook,
  White_Instagram,
  White_Twitter,
  White_Linkedin,
} from "../../controller/Images";
import { ContactData } from "../../controller/ContactData";

function MobileFooter() {
  const insightsItem = navItems.find((item) => item.name === "Insights");
  return (
    <div className={`container-fluid p-0 ${styles.mobile_footer}`}>
      {/* First Section (Company Logo) */}
      <div className="d-flex flex-column align-items-center text-center pt-2 w-100">
        <img src={Colorlogo} alt="Company Logo" height="110" />
      </div>

      {/* Second Section (Navigation Links) */}
      <div
        className={`d-flex flex-column align-items-start text-start pt-3 w-100 px-3 ${styles.footer_links}`}
      >
        <h5>OUR COMPANY</h5>
        <ul className="list-unstyled">
          {Navlink.filter((item) =>
            [
              "Home",
              "Success Stories",
              "Join Our Team",
              "Let's Talk",
              "Insights",
            ].includes(item.name),
          ).map((item, index) => {
            const isGroupLabel =
              item.name === "Insights" && insightsItem?.children?.length;

            return (
              <li key={index}>
                {isGroupLabel ? (
                  <span className={styles.groupLabel}>{item.name}</span>
                ) : (
                  <a href={item.path}>{item.name}</a>
                )}

                {item.name === "Insights" && insightsItem?.children && (
                  <ul
                    className="list-unstyled"
                    style={{ paddingLeft: "20px", marginTop: "4px" }}
                  >
                    {insightsItem.children.map((child, childIndex) => (
                      <li key={childIndex}>
                        <a href={child.path}>{child.name}</a>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>

        <h5 className="mt-3">SERVICES AND PRODUCTS</h5>
        <ul className="list-unstyled">
          {Navlink.filter((item) =>
            ["Services", "AI", "Products", "Cloud", "ERP"].includes(item.name),
          ).map((item, index) => (
            <li key={index}>
              <a href={item.path}>{item.name}</a>
            </li>
          ))}
        </ul>
      </div>

      {/* Third Section (Certifications) */}
      <div
        className={`d-flex flex-column align-items-center text-center pt-3 w-100 ${styles.certification_section}`}
      >
        <img src={mslogo} alt="MS Logo" height="70" />
        <div className="d-flex gap-3 mt-2">
          <img src={quality} alt="Quality Logo" height="100" />
          <img src={ISO} alt="ISO Logo" height="100" />
        </div>
      </div>

      {/* Contact Information */}
      {/* Contact & Social Section */}
      <div className={`container-fluid mt-4 py-4 ${styles.address_title}`}>
        <div className="row px-5">
          {/* COL-12 Contact Info */}
          <div className="col-12 mb-4">
            <ul className="list-unstyled">
              {/* Email */}
              <li className="d-flex align-items-start mb-2">
                <img src={email} alt="Email Icon" height="30" />
                <p className="mb-0 ms-2">{ContactData[0].text}</p>
              </li>

              {/* Phone */}
              <li className="d-flex align-items-start mb-2">
                <img src={phone} alt="Phone Icon" height="30" />
                <p className="mb-0 ms-2">{ContactData[1].text}</p>
              </li>

              {/* Address */}
              <li className="d-flex align-items-start">
                <img src={place} alt="Location Icon" height="30" />
                <p className="mb-0 ms-2">{ContactData[2].text}</p>
              </li>
            </ul>
          </div>

          {/* COL-12 Follow Section */}
          <div className="col-12 text-start">
            <h5 style={{ color: "#fff" }} className="mb-3">
              Follow
            </h5>
            <ul className="list-unstyled d-flex flex-column gap-2 m-0">
              <li>
                <a
                  href="https://www.linkedin.com/company/bharatclouds/about/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.footerLink}
                >
                  <img
                    src={White_Linkedin}
                    alt="LinkedIn"
                    height="20"
                    className="me-2"
                  />
                  LinkedIn
                </a>
              </li>
              <li>
                <a
                  href="https://x.com/BharatClouds"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.footerLink}
                >
                  <img
                    src={White_Twitter}
                    alt="Twitter"
                    height="20"
                    className="me-2"
                  />
                  X
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/bharatcloudspvtltd/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.footerLink}
                >
                  <img
                    src={White_Facebook}
                    alt="Facebook"
                    height="20"
                    className="me-2"
                  />
                  Facebook
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/bharatclouds/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.footerLink}
                >
                  <img
                    src={White_Instagram}
                    alt="Instagram"
                    height="20"
                    className="me-2"
                  />
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Footer Bottom Section - unchanged */}
      <div className="footer_bottom d-flex flex-column align-items-center text-center mb-5 w-100">
        <div className={`mt-3 ${styles.copy}`}>
          <p className="m-0">
            Copyright © {new Date().getFullYear()} Bharat Clouds Private
            Limited. All rights reserved.
          </p>
        </div>

        <div className={`mt-2 ${styles.privacy_links}`}>
          <ul className="list-unstyled d-flex gap-2 m-0">
            <li>
              <a href="/terms-of-use">Terms of Use</a>
            </li>
            <li>/</li>
            <li>
              <a href="/privacy-policy">Privacy Policy</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default MobileFooter;
